import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { colors } from '@/theme/colors';

const AuthLinks = () => {
  const { t } = useTranslation();
  return (
    <LoginMenu>
      <StyledLink
        href="https://r2playground.com/home/join"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('signUp')}
      </StyledLink>
      <Divider>|</Divider>
      <StyledLink
        href="https://r2playground.com/home/password/find"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('findPassword')}
      </StyledLink>
    </LoginMenu>
  );
};

export default AuthLinks;

const LoginMenu = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  font-size: 18px;
`;

const StyledLink = styled.a`
  text-decoration: none;
  color: ${colors.link};
`;

const Divider = styled.div``;
